/**
 * MVP scoring hook for the Gap Management score sheet (Phase D — spec §8-D).
 * Thin selector over useMvpPathwayReport: same engine, same inputs as the Pathway
 * Report, returning ONE pathway's result for header-card display.
 *
 * DISPLAY-ONLY: nothing here persists. Traditional-mode scoring (auto-calc →
 * POST /mips/scores/calculate) is untouched and gated off while previewing.
 * Pass `undefined` practiceId to disable all underlying queries (Traditional mode).
 */
import { normalizeMvpId } from '../mips-data-service';
import { useMvpPathwayReport } from './assemble-inputs';
import type { PathwayResult } from './types';

export interface MvpScoringState {
  /** The engine result for the requested MVP; null while loading/unavailable. */
  row: PathwayResult | null;
  loading: boolean;
  ready: boolean;
}

export function useMvpScoring(
  practiceId: number | string | undefined,
  year: number,
  mvpId: string | null,
  subgroupId: number | null = null,
): MvpScoringState {
  const state = useMvpPathwayReport(practiceId, year, {}, subgroupId);
  const row = mvpId
    ? state.report.find(r => r.pathwayId === normalizeMvpId(mvpId)) ?? null
    : null;
  return { row, loading: state.loading, ready: state.ready };
}
